import socketIOClient from "socket.io-client";
const ENDPOINT = window.appConfig.endpoints.bff_node;
//const socket = socketIOClient(ENDPOINT);
var connectionOptions =  {
  "transports" : ["websocket"]                
}
export const socket = require("socket.io-client")(ENDPOINT, connectionOptions);  
